// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__nDqPt","form":"styles_form__2IFw7"};